import dynamic from 'next/dynamic'
import { useReelsBB } from '../../../contexts/providers/ReelsBBProvider'
import { ITimeLineVerticalPlayerBlock } from '../../../types'

const Reels = dynamic(() => import('../../BigBrother/Reels'), { ssr: false })

type Props = {
  data: ITimeLineVerticalPlayerBlock
}

const TimeLineVerticalPlayer = ({ data }: Props) => {
  const { grid_id, grid_title, grid_type, newsroom_name, showBlock } = data

  // Contexts
  const { videos } = useReelsBB()

  if (!videos.length || !showBlock) {
    return null
  }

  return (
    <Reels
      data={{
        posts: videos,
        grid_title: grid_title,
        newsroom_name: newsroom_name,
        grid_type: 'VerticalPlayerComponent',
        grid_id: grid_id,
        block_type: grid_type,
        isMiniSeries: false,
        isBigBrother: true,
      }}
    />
  )
}

export default TimeLineVerticalPlayer
